import { SEARCH_TERM_TRIMMED } from '../search/searchEvents';
import type { SimpleStore } from '../../state/SimpleStore';

/**
 * Kürzt den eingegebenen Suchbegriff
 */
export function trimSearchTerm(simpleStore: SimpleStore): void {
  simpleStore.dispatch(SEARCH_TERM_TRIMMED());
}
